import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { AppointmentManualEditor } from "../AppointmentManual/AppointmentManual.editor";
import { AppointmentGroupManualEditor } from "../AppointmentGroupManual/AppointmentGroupManual.editor";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { _ImportEmployeeFactors, _ImportEmployeeFactorsByexe, _ProcessImported } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { FileInput } from "../../../theme/Component/FileInput";
import { AccountantYear } from "../../GestionTH/EmployeeContract/ProductionPlan/AccountantYear";
import { MonthEditorbyconst } from "../../../RemoteAbstractAction/editors/MonthEditorbyconst";
import { PayrollTypeSelect } from "../PayrollFactor/PayrollTypeSelect";
import { PayrollImportedDataCatalog } from "./PayrollImportedDataCatalog";


export const FortnightImport = () => {

    const impForg = useDataBean(_ImportEmployeeFactors);
    const impfactors = useDataBean(_ImportEmployeeFactorsByexe);
    const procces = useDataBean(_ProcessImported);

    const single = Singleton.getInstance();
    const [formato, setFormato] = useState<any>([]);
    const [formatodos, setFormatodos] = useState<any>([]);
    const [formatotres, setFormatotres] = useState<any>([]);
    const [lista, setLista] = useState<any>([]);
    const [fileI, setFileI] = useState<any>({});
    const [modalverimpfactorsarchivo, setModalverimpfactorsarchivo] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalverimppend, setModalverimpend] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaltable, setModaltable] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modalarchivo, setModalarchivo] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modallink, setModallink] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modallinkdos, setModallinkdos] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modallinktre, setModallinktre] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    const processImportedEmployeeFactors = () => {
        if (!procces.bean.IDPayrollType) {
            toast.warning("Debe cargar un Archivo.");
            return;
        }
        procces.instance.processImportedEmployeeFactors(procces.bean.IDPayrollType).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Factores Salariales Importados Pendientes')
                    setFormatotres(resp[0]);
                    setModallinktre({ ...modallinktre, "view": true })
                    console.log(resp)
                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }
    const importEmployeeFactors = () => {
        if (!impForg.bean.Media) {
            toast.warning("Debe cargar un Archivo.");
            return;
        }
        impForg.instance.importEmployeeFactors(impForg.bean.Media, impForg.bean.MediaContext, null, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Factores Salariales Importados')
                    setFormato(resp[0]);
                    setModallink({ ...modallink, "view": true })
                    console.log(resp)
                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }
    const importEmployeeFactorsByexe = () => {
        if (!impfactors.bean.Year) {
            toast.warning("Debe cargar un Año.");
            return;
        }
        if (!impfactors.bean.Month) {
            toast.warning("Debe cargar un Mes.");
            return;
        }
        impfactors.instance.importEmployeeFactorsByexe(impfactors.bean.Year, impfactors.bean.Month, impfactors.bean.Media, impfactors.bean.MediaContext, null, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Factores Salariales Nomina Importados')
                    setFormatodos(resp[0]);
                    setModallinkdos({ ...modallinkdos, "view": true })
                    // console.log(resp)
                    console.log(resp)
                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const verimpfactors = () => {
        setModalarchivo({ ...modalarchivo, "view": true })
    }

    const verimpfactorsarchivo = () => {
        setModalverimpfactorsarchivo({ ...modalverimpfactorsarchivo, "view": true })
    }
    const verimpfactorspendientes = () => {
        setModalverimpend({ ...modalverimppend, "view": true })
    }
    const vertable = () => {
        setModaltable({ ...modaltable, "view": true })
    }
    return (
        <BasicPage titulo="Importar Factores Salariales">
            <div className="row">

                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-database-2-line" eventClick={verimpfactors}> Importar Factores Salariales desde Archivo Excel vertical</BasicButton>
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-database-2-line" eventClick={verimpfactorsarchivo}>Importar Factores Salariales desde Archivo Excel Formato Nómina</BasicButton>
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-database-2-line" eventClick={verimpfactorspendientes}>Importar Factores Salariales Pendientes</BasicButton>
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-database-2-line" eventClick={vertable}>Factores Salariales Importados</BasicButton>
                </div>
                <div className="col-md-12">
                    <Modal modal={modaltable} updateModal={setModaltable}>
                        <div className="row">
                            <PayrollImportedDataCatalog />
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalverimppend} updateModal={setModalverimpend} eventModal={processImportedEmployeeFactors}>
                        <div className="row">
                            <div className="col-md-12">
                                <PayrollTypeSelect idSelector={procces.bean.IDPayrollType} onChange={(e) => { procces.setBean({ ...procces.bean, "IDPayrollType": e }) }} />
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modallinktre} updateModal={setModallinktre}>
                        <div className="row">
                            <div className="col-md-12">
                                {formatotres?.DataBeanProperties?.URLLink && (
                                    // <PrintJson json={formato.DataBeanProperties.URLLink} />
                                    <div className="row">
                                        <div className="col-md-12 mt-3">
                                            <label>Descarga en el Siguiente Link:*</label>
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <a href={formatotres.DataBeanProperties.URLLink} target="_blank" rel="noopener noreferrer">
                                                <strong>📄 {formatotres.DataBeanProperties.Filename}</strong>
                                            </a>
                                        </div>
                                    </div>

                                )}
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalverimpfactorsarchivo} updateModal={setModalverimpfactorsarchivo} eventModal={importEmployeeFactorsByexe}>
                        <div className="row">
                            <div className="col-md-6">
                                <AccountantYear idSelector={impfactors.bean.Year} onChange={(e) => { impfactors.setBean({ ...impfactors.bean, "Year": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <MonthEditorbyconst idSelector={impfactors.bean.Month} onChange={(e) => { impfactors.setBean({ ...impfactors.bean, "Month": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <div className="col-md-6">
                                    <FileInput
                                        label='Archivo a importar'
                                        directory='ImpoFactorSalarial'
                                        onCreate={({ Media, MediaContext }) => { impfactors.setBean({ ...impfactors.bean, "Media": Media, "MediaContext": MediaContext }) }}
                                    />
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modallinkdos} updateModal={setModallinkdos}>
                        <div className="row">
                            <div className="col-md-12">
                                {formatodos?.DataBeanProperties?.URLLink && (
                                    // <PrintJson json={formato.DataBeanProperties.URLLink} />
                                    <div className="row">
                                        <div className="col-md-12 mt-3">
                                            <label>Descarga en el Siguiente Link:*</label>
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <a href={formatodos.DataBeanProperties.URLLink} target="_blank" rel="noopener noreferrer">
                                                <strong>📄 {formatodos.DataBeanProperties.Filename}</strong>
                                            </a>
                                        </div>
                                    </div>

                                )}
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalarchivo} updateModal={setModalarchivo} eventModal={importEmployeeFactors}>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="col-md-6">
                                    <FileInput
                                        label='Archivo a importar'
                                        directory='ImpoFactorSalarial'
                                        onCreate={({ Media, MediaContext }) => { impForg.setBean({ ...impForg.bean, "Media": Media, "MediaContext": MediaContext }) }}
                                    />

                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modallink} updateModal={setModallink}>
                        <div className="row">
                            <div className="col-md-12">
                                {formato?.DataBeanProperties?.URLLink && (
                                    // <PrintJson json={formato.DataBeanProperties.URLLink} />
                                    <div className="row">
                                        <div className="col-md-12 mt-3">
                                            <label>Descarga en el Siguiente Link:*</label>
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <a href={formato.DataBeanProperties.URLLink} target="_blank" rel="noopener noreferrer">
                                                <strong>📄 {formato.DataBeanProperties.Filename}</strong>
                                            </a>
                                        </div>
                                    </div>

                                )}
                            </div>
                        </div>
                    </Modal>
                </div>

            </div>
        </BasicPage>
    )
}